import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { filter, slice } from 'lodash'

import {
  getNextPost,
  getPostsByIds,
  getPostsBySlugs,
  getPreviousPost,
} from '../reducers'
import PostView from '../components/post-view'
import { FEATURED_POSTS_COLLECTION_SLUG } from '../constants'

const MIN_RELATED_POSTS_COUNT = 3
const POPULAR_POSTS_COUNT = 5

const mapStateToProps = (state, ownProps) => {
  let post = state.posts[ownProps.postSlug]
  let emailUrls = ownProps.emailUrls
  // Popular posts: first N, excluding the current post
  let popularPosts = getPostsBySlugs(
    filter(
      state.collections[FEATURED_POSTS_COLLECTION_SLUG].itemIds,
      (slug) => slug != post.slug
    ),
    state
  )

  // Related posts: editorial, back-filled with popular posts
  let relatedPosts = getPostsByIds(post.relatedPostIds, state)

  let nextPost = getNextPost(state, post)
  let previousPost = getPreviousPost(state, post)
  // Backfill first with popular posts NOT in the top N
  if (relatedPosts.length < MIN_RELATED_POSTS_COUNT) {
    let popularPostsNotOnPage = slice(
      popularPosts,
      POPULAR_POSTS_COUNT,
      POPULAR_POSTS_COUNT + (MIN_RELATED_POSTS_COUNT - relatedPosts.length)
    )
    relatedPosts = relatedPosts.concat(popularPostsNotOnPage)
  }
  // Backfill next starting at the top of the popular posts list
  if (relatedPosts.length < MIN_RELATED_POSTS_COUNT) {
    let topPopularPosts = slice(
      popularPosts,
      0,
      MIN_RELATED_POSTS_COUNT - relatedPosts.length
    )
    relatedPosts = relatedPosts.concat(topPopularPosts)
  }

  if (post?.body && !ownProps?.post?.body) {
    // Since posts set content via dangerouslySetInnerHTML
    // we need to manually mount react components that are
    // rendered within posts so that they function as react
    // components again when navigating via react-router.
    // The setTimeout with a value of 0 pushes this function call into
    // the next event loop which gives the component a chance to
    // inject the post body before we run the mounting script.
    setTimeout(() => ReactRailsUJS.mountComponents('.ujs-mount-point'), 0)
  }

  return {
    popularPosts: slice(popularPosts, 0, POPULAR_POSTS_COUNT),
    post: post,
    relatedPosts: relatedPosts,
    nextPost: nextPost,
    previousPost: previousPost,
    emailUrls: emailUrls,
    minimalView: ownProps.minimalView,
  }
}

const Post = connect(mapStateToProps)(PostView)

Post.propTypes = {
  postSlug: PropTypes.string.isRequired,
}

export default Post
